import request from '@/utils/request'

// 查询列表
export function apiWorkCenterList(query) {
  return request({
    url: '/bom/workCenter/list',
    method: 'get',
    params: query
  })
}

// 查询树形列表
export function apiWorkCenterTreeList(query) {
  return request({
    url: '/bom/workCenter/treeList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiWorkCenterUpdate (data) {
  return request({
    url: '/bom/workCenter/save',
    method: 'post',
    data: data
  })
}

// 导出列表
export function apiWorkCenterExport (data) {
  return request({
    url: '/bom/workCenter/export',
    method: 'post',
    data: data
  })
}

// 删除
export function apiWorkCenterDel (id) {
  return request({
    url: '/bom/workCenter/remove',
    method: 'post',
    data: id
  })
}
